import React from 'react';

const PostsIcon = ({ color = '#757575', width = 20, height = 20, ...rest }, ref) => {
  return (
    <svg
      {...rest}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}>
      <path
        d="M1.9861 11.4968C1.61441 8.86046 1.42856 7.54231 2.21844 6.68913C3.00831 5.83594 4.41448 5.83594 7.22683 5.83594H12.7728C15.5852 5.83594 16.9914 5.83594 17.7812 6.68913C18.5711 7.54231 18.3853 8.86046 18.0136 11.4968L17.6611 13.9968C17.3696 16.0642 17.2239 17.0979 16.4762 17.7169C15.7286 18.3359 14.6258 18.3359 12.4204 18.3359H7.57931C5.37384 18.3359 4.27111 18.3359 3.52345 17.7169C2.77579 17.0979 2.63005 16.0642 2.33857 13.9968L1.9861 11.4968Z"
        stroke={color}
        strokeWidth="1.25"
      />
      <path
        d="M16.3013 5.83333C16.4918 4.74603 15.6551 3.75 14.5513 3.75H5.44807C4.34419 3.75 3.50752 4.74603 3.69804 5.83333"
        stroke={color}
        strokeWidth="1.25"
      />
      <path
        d="M14.5833 3.7474C14.6069 3.5315 14.6187 3.42352 14.6189 3.33435C14.6208 2.48133 13.9783 1.7646 13.1301 1.67358C13.0415 1.66406 12.9329 1.66406 12.7156 1.66406H7.28416C7.06695 1.66406 6.95835 1.66406 6.86969 1.67358C6.02153 1.7646 5.37901 2.48133 5.38086 3.33435C5.38106 3.42352 5.39288 3.53148 5.41653 3.7474"
        stroke={color}
        strokeWidth="1.25"
      />
      <circle cx="13.75" cy="9.58594" r="1.25" stroke={color} strokeWidth="1.25" />
      <path
        d="M16.6666 16.6641L14.2631 14.8736C13.488 14.2962 12.3337 14.2387 11.4805 14.735L11.2582 14.8643C10.6653 15.2092 9.8587 15.1514 9.34629 14.7272L6.14782 12.0798C5.50941 11.5514 4.48537 11.5232 3.80592 12.0153L2.70264 12.8143"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default React.forwardRef(PostsIcon);
